import React from 'react';
import InfoIcon from '@/shared/icons/InfoIcon';
import DTooltip from '@/components/Global/DTooltip';
import NewBadge from '@/components/Global/NewBadge';
import CheckmarkIcon from '@/components/DModalPlans/CheckmarkIcon';

const MESSAGES_TOOLTIP =
  'This is the maximum number of messages your AI agent will send per month, depending on which LLM you use. For a full breakdown of LLM message costs, visit the FAQ here.';

const PlanCardFeatures = ({ features }) => {
  return (
    <div className="flex flex-col items-center self-stretch pt-v3-lg gap-v3-sm flex-1 min-h-0 max-h-[400px]">
      <ul className="flex flex-col gap-v3-xs overflow-y-auto no-scrollbar w-full">
        {features.map((feature, featureIndex) => {
          return (
            <li key={featureIndex} className="flex items-center gap-v3-xs self-stretch">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                {feature.label.includes('Everything in') ? (
                  <span className="w-5 h-5"></span>
                ) : (
                  <CheckmarkIcon />
                )}
              </div>
              <div className="flex items-center gap-v3-xs flex-1">
                <span
                  className={`
                    font-inter-variable text-v3-h11 font-regular leading-[22px] text-v3-black-max
                    ${feature.label.includes('Everything in') ? 'font-[500]' : ''}
                    ${feature.underlineTooltip ? 'border-b border-dotted border-v3-black-border' : ''}
                  `}
                >
                  {!feature.underlineTooltip ? (
                    // <span className="flex items-center gap-1 font-inherit">
                      feature.label
                    
                    // </span>
                  ) : (
                    <DTooltip content={feature.content} position="bottom">
                      <span className="flex items-center gap-1">
                        {feature.label}
                        {/* {feature.showNewBadge && <NewBadge className="ml-1" />} */}
                      </span>
                    </DTooltip>
                  )}
                </span>
                {feature.hasTooltip && (
                  <DTooltip
                    position="bottom"
                    content={
                      <div className="max-w-[250px]">
                        <p>
                          {MESSAGES_TOOLTIP}{' '}
                          <a
                            href="https://www.dante-ai.com/pricing"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#fff] underline"
                          >
                            Learn more
                          </a>{' '}
                        </p>
                      </div>
                    }
                  >
                    <InfoIcon className="w-4 h-4 text-v3-blue-primary cursor-help flex-shrink-0" />
                  </DTooltip>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PlanCardFeatures;

